import {RegisterOptions} from 'react-hook-form'

export enum SiemMethod {
  HTTP = 'http',
  S3 = 's3',
}

// SIEM HTTP types
export enum SiemType {
  Splunk = 'Splunk',
  QRadar = 'QRadar',
  Taegis = 'Taegis',
  MSSentinel = 'MSSentinel',
  CrowdStrike = 'CrowdStrike',
  Datadog = 'Datadog',
  Elasticsearch = 'Elasticsearch',
  Other = 'Other',
}

export enum SiemHttpStatus {
  NotConfigured = 'NOT_CONFIGURED',
  Ok = 'OK',
  Failure = 'FAILURE',
}

export enum SiemS3Status {
  NotConfigured = 'NOT_CONFIGURED',
  PolicyGenerated = 'POLICY_GENERATED',
  Ok = 'OK',
  Failure = 'FAILURE',
}

export enum CreateSiemS3ActionType {
  GeneratePolicy = 'generate_policy',
  SyncBucket = 'sync_bucket',
}

export interface SiemFieldDetail {
  labelKey: string
  value: string
}

export interface SiemTypeConfig {
  payloadType: SiemFieldDetail
  batchFormat: SiemFieldDetail
  maxPayloadSize: SiemFieldDetail
  documentation?: SiemFieldDetail
}

export type SiemConfigDetails = Record<SiemType, SiemTypeConfig>

export interface SiemTypeOption {
  label: string
  value: SiemType
}

export interface GetSiemHttpIntegrationResponse {
  config?: GenericSiemHttpConfig | MSSentinelSiemHttpConfig
  status: SiemHttpStatus
  lastSynced?: string
}

export interface BaseSiemHttpConfig {
  targetTool: SiemType
}

export type SiemTypeExcludeMSSentinel = Exclude<SiemType, SiemType.MSSentinel>
export interface GenericSiemHttpConfig {
  targetTool: SiemTypeExcludeMSSentinel
  ingestURL: string
  accessToken: string
}

export interface MSSentinelSiemHttpConfig {
  targetTool: SiemType.MSSentinel
  msTenantId: string
  msClientId: string
  msClientSecret: string
  dceIngestURL: string
  dcrImmutableId: string
  customTableName: string
}

export type SiemHttpConfig = GenericSiemHttpConfig | MSSentinelSiemHttpConfig
export type PostSiemHttpIntegrationRequest = SiemHttpConfig

export interface PostSiemHttpIntegrationResponse {
  status: SiemS3Status
}

export interface PostSiemHttpSettingResponse {
  status: SiemHttpStatus
}

export interface GetSiemS3IntegrationResponse {
  config?: SiemS3ConfigNode
  status: SiemS3Status
  lastSynced?: string
  error?: string | null
  region?: string
}

export interface SiemS3ConfigNode {
  bucketName: string
  region: string
  policy?: Record<string, string>
}

export interface PostSiemS3IntegrationAction {
  bucketName: string
  actionType: CreateSiemS3ActionType
}

// SIEM HTTP input form types
export interface SiemTypeInputFormMapping {
  formField1: SiemTypeFormField
  formField2: SiemTypeFormField
  formField3?: SiemTypeFormField
  formField4?: SiemTypeFormField
  formField5?: SiemTypeFormField
  formField6?: SiemTypeFormField
}
export interface SiemTypeFormField {
  placeholderKey: string
  onEditClickPayload: string[]
  validationRules:
    | Omit<
        RegisterOptions<SiemHttpInputFormState, keyof SiemHttpInputFormState>,
        'setValueAs' | 'disabled' | 'valueAsNumber' | 'valueAsDate'
      >
    | undefined
  isMasked?: boolean
}

export interface SiemHttpDynamicFormState {
  formField1: string
  formField2: string
  formField3?: string
  formField4?: string
  formField5?: string
  formField6?: string
}

export interface SiemHttpInputFormState extends SiemHttpDynamicFormState {
  siemType: SiemTypeOption | null
}
